import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/centrosColaboradores';
import ListarCentros from './ListarCentros';

const ms2p = (state) => {
    return {
        ...state.centrosColaboradores,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ListarCentros);
